export enum EventTypes {
    POPUP_CLOSED = 'POPUP_CLOSED',
    POPUP_FINISHED = 'POPUP_FINISHED',
    POPUP_MOUNTED = 'POPUP_MOUNTED',
    SEND_DATA = 'SEND_DATA',
    SEND_TRANSACTION_DATA = 'SEND_TRANSACTION_DATA',
    SIGNER_FINISHED = 'SIGNER_FINISHED',
    TRANSACTION_EXECUTED = 'TRANSACTION_EXECUTED',
    TRANSACTION_SIGNED = 'TRANSACTION_SIGNED',
    CHECK_AUTHENTICATED = 'CHECK_AUTHENTICATED',
    AUTHENTICATE = 'AUTHENTICATE',
    LOGOUT = 'LOGOUT',
}
